"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const constants_1 = require("../../constants");
const is_empty_1 = __importDefault(require("../../utils/is-empty"));
const message_defaults_json_1 = __importDefault(require("../../message-defaults.json"));
const messageDefault = message_defaults_json_1.default.maxDate;
const validationBuilder = (max, format = constants_1.DATE_FORMAT, message = messageDefault) => (value) => {
    const createMoment = (dateString) => (0, moment_1.default)(dateString, format, true);
    if (!(0, is_empty_1.default)(value) && createMoment(value).isAfter(createMoment(max), 'day')) {
        return message;
    }
    return null;
};
validationBuilder.messageDefault = messageDefault;
exports.default = validationBuilder;
